import { onMounted, onUnmounted, readonly, ref, type Ref } from 'vue';

export const NOW_INTERVAL_MS = 30_000;

const now = ref(Date.now());
let users = 0;
let timer: ReturnType<typeof setInterval> | undefined;

/** The current time in ms, refreshed by one timer shared by every mounted component that uses it. */
export function useNow(): Readonly<Ref<number>> {
  if (users === 0) now.value = Date.now();
  onMounted(() => {
    if (users++ > 0) return;
    timer = setInterval(() => (now.value = Date.now()), NOW_INTERVAL_MS);
  });
  onUnmounted(() => {
    if (--users > 0) return;
    clearInterval(timer);
    timer = undefined;
  });
  return readonly(now);
}
